import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d09e156&scoped=true&lang=html&"
import script from "./marketingConfirmOrder.js?vue&type=script&lang=js&"
export * from "./marketingConfirmOrder.js?vue&type=script&lang=js&"
import style0 from "./marketingConfirmOrder.styl?vue&type=style&index=0&id=6d09e156&lang=stylus&scoped=true&"
import style1 from "./resetVant.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d09e156",
  null
  
)

export default component.exports